import { render, staticRenderFns } from "./CatalogProductPublishedVariants.vue?vue&type=template&id=270af46a&scoped=true&"
import script from "./CatalogProductPublishedVariants.vue?vue&type=script&lang=js&"
export * from "./CatalogProductPublishedVariants.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductPublishedVariants.vue?vue&type=style&index=0&id=270af46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270af46a",
  null
  
)

export default component.exports